import type { InboxItem } from '../../api/inbox'

export interface InboxGroup {
  groupKey: string
  label: string
  items: InboxItem[]
  totalImpact: number
}

export const SOURCE_LABELS: Record<string, string> = {
  harvest: 'Auto-Harvest',
  rule: 'Regel-Engine',
  recommendation: 'Empfehlung',
  portfolio: 'Portfolio',
  experiment: 'Experiment',
  ai_task: 'KI-Aufgabe',
  manual: 'Manuell',
}

export const KIND_LABELS: Record<string, string> = {
  bid_increase: 'Bid erhoehen',
  bid_decrease: 'Bid senken',
  negative: 'Negative setzen',
  graduation: 'Graduation',
  keyword_create: 'Keyword uebernehmen',
  other: 'Sonstige',
}

// Fail-closed-Guard: Amazon-wirksame Aktionen (Freigeben/Anwenden/Übernehmen) nur, wenn
// Ziel UND Effekt der Entscheidung bekannt sind. Bestandsformen ohne Kontext
// (keyword-lose Deactivate-/Portfolio-Drafts → "Ohne Zuordnung", Rule-Events ohne Effekt)
// bleiben so nach Demo-Aufhebung gesperrt, bis Fenster A die Felder normalisiert/befüllt.
export function isActionable(item: InboxItem): boolean {
  const targetKnown = Boolean(item.campaignName || item.keywordText || item.searchTerm)
  const effectKnown = Boolean(
    item.expectedEffect?.kind || item.eventType || (item.suggestedBid && item.bidAtEventTime),
  )
  return targetKnown && effectKnown
}

export function groupInboxItems(items: InboxItem[]): InboxGroup[] {
  const map = new Map<string, InboxGroup>()
  for (const it of items) {
    const kind = (it.expectedEffect?.kind as string | undefined) ?? 'other'
    const key = `${it.source}:${kind}`
    const existing = map.get(key)
    if (existing) {
      existing.items.push(it)
      existing.totalImpact += it.impactSpend
    } else {
      map.set(key, {
        groupKey: key,
        label: `${SOURCE_LABELS[it.source] ?? it.source} — ${KIND_LABELS[kind] ?? kind}`,
        items: [it],
        totalImpact: it.impactSpend,
      })
    }
  }
  const groups = [...map.values()]
  for (const g of groups) g.items.sort((a, b) => b.impactSpend - a.impactSpend)
  groups.sort((a, b) => b.totalImpact - a.totalImpact)
  return groups
}
